import React from 'react';
import moment from 'moment';
import DateField from '../DateField/DateField';
import ErrorRender from '../ErrorRender/ErrorRender';

const Datepicker = (props) => {
  const {
    input,
    meta,
    customClass,
    selectedValue,
    onChange,
    placeholder,
    placeholderText,
    minDate,
    maxDate,
    initDate,
    yearLimit,
    disabled,
    clearable,
    name,
    testId,
    inputTestId,
    open
  } = props;
  const fieldProps = {
    customClass,
    placeholder,
    placeholderText,
    minDate,
    maxDate,
    initDate,
    yearLimit,
    disabled,
    clearable,
    testId,
    inputTestId,
    alwaysOpen: Boolean(open)
  };

  const binding = input
    ? {
        name: input.name,
        selectedValue: input.value,
        onChange: (date) => input.onChange(date ? moment(date).toDate() : null),
        onBlur: input.onBlur
      }
    : { name, selectedValue, onChange };
  const field = <DateField {...fieldProps} {...binding} />;
  const hasError = Boolean(meta?.error && meta?.touched);

  if (!input) return field;

  return (
    <div className={hasError ? 'has-error' : ''}>
      {field}
      <ErrorRender {...props} />
    </div>
  );
};

export default Datepicker;
